import { Injectable } from '@angular/core';
import { DwAction, DwActionHandler, DwActionResult, DwActionType, DwMetaDataGridActionState, DwOrmDataService, DwOrmDataServiceToken } from '@devwareapps/devware-cap';
import { Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChallengeTeamJoinRequestEntity, ChallengeTeamJoinRequestStatusAllItems } from '../../../meta-data/app-meta-data.service';

@DwAction({
    keyName: 'reject-join-request',
    display: 'Reject Request',
    actionType: DwActionType.menuAction,
    isGlobal: true,
    allowOnce: true,
    configData: {
        requireValidation: false,
        redirectAfter: false,
        actionMessage: '',
    }
})
@Injectable()
export class RejectJoinRequestActionService implements DwActionHandler {


    constructor(
        @Inject(DwOrmDataServiceToken) private ormDataService: DwOrmDataService,
    ) {}

    handleAction(actionState: DwMetaDataGridActionState<ChallengeTeamJoinRequestEntity>): Observable<DwActionResult> {
        const result = new DwActionResult();
        const joinRequest = actionState?.selectedItem || actionState?.data;

        if (!joinRequest) {
            result.success = false;
            result.cancelled = true;
            return of(result);
        }

        const updatedRequest = { ...joinRequest, ChallengeTeamJoinRequestStatusId: ChallengeTeamJoinRequestStatusAllItems.Rejected };

        return this.ormDataService.saveEntity(updatedRequest).pipe(
            map(() => {
                result.success = true;
                return result;
            })
        );
    }
}
